import axiosInstance from "auth/FetchInterceptor";
import { PREFIX } from "constants/ApiConstant";

const BASE = `${PREFIX}/DaiHoiCoDong`;
const CRM_BASE_URL = { baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL };

const DaiHoiCoDongService = {};

DaiHoiCoDongService.searchGrid = function (data) {
  return axiosInstance.post(`${BASE}/search-grid`, data, CRM_BASE_URL);
};

DaiHoiCoDongService.getById = function (id) {
  return axiosInstance.get(`${BASE}/get-by-id?id=${id}`, CRM_BASE_URL);
};

DaiHoiCoDongService.create = function (data) {
  return axiosInstance.post(`${BASE}/create`, data, CRM_BASE_URL);
};

DaiHoiCoDongService.update = function (data) {
  return axiosInstance.put(`${BASE}/update`, data, CRM_BASE_URL);
};

DaiHoiCoDongService.delete = function (id) {
  return axiosInstance.delete(`${BASE}/delete?id=${id}`, CRM_BASE_URL);
};

DaiHoiCoDongService.checkIn = function () {
  return axiosInstance.get(`${BASE}/check-in`, CRM_BASE_URL);
};

DaiHoiCoDongService.importExcel = function (id) {
  return axiosInstance.get(`${BASE}/import-excel?transId=${id}`, CRM_BASE_URL);
};

DaiHoiCoDongService.updateImportExcel = function (data) {
  return axiosInstance.put(`${BASE}/import-excel`, data, CRM_BASE_URL);
};

DaiHoiCoDongService.importExcelByTransId = function (id) {
  return axiosInstance.get(
    `${BASE}/get-import-by-transId?transId=${id}`,
    CRM_BASE_URL
  );
};

// DanhMucBieuQuyet endpoints
DaiHoiCoDongService.searchDanhMucBieuQuyet = function (data) {
  return axiosInstance.post(
    `${BASE}/bieu-quyet/search-grid`,
    data,
    CRM_BASE_URL
  );
};

DaiHoiCoDongService.getDanhMucBieuQuyetById = function (id) {
  return axiosInstance.get(
    `${BASE}/bieu-quyet/get-by-id?id=${id}`,
    CRM_BASE_URL
  );
};

DaiHoiCoDongService.createDanhMucBieuQuyet = function (data) {
  return axiosInstance.post(`${BASE}/bieu-quyet/create`, data, CRM_BASE_URL);
};

DaiHoiCoDongService.updateDanhMucBieuQuyet = function (data) {
  return axiosInstance.put(`${BASE}/bieu-quyet/update`, data, CRM_BASE_URL);
};

DaiHoiCoDongService.deleteDanhMucBieuQuyet = function (id) {
  return axiosInstance.delete(
    `${BASE}/bieu-quyet/delete?id=${id}`,
    CRM_BASE_URL
  );
};

// Update voting order (dnd-kit)
DaiHoiCoDongService.updateVotingOrder = function (items) {
  return axiosInstance.put(`${BASE}/bieu-quyet/update-order`, items, {
    ...CRM_BASE_URL,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// Update voting status (Switch)
DaiHoiCoDongService.updateVotingStatus = function (ids, trangThai) {
  return axiosInstance.put(
    `${BASE}/bieu-quyet/update-status`,
    {
      ids,
      trangThai,
    },
    {
      ...CRM_BASE_URL,
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

// Total shares endpoints
DaiHoiCoDongService.getTotalShares = function () {
  return axiosInstance.get(`${BASE}/total-co-phan-dhcd`, CRM_BASE_URL);
};

DaiHoiCoDongService.updateTotalShares = function (totalShares) {
  return axiosInstance.put(`${BASE}/total-co-phan-dhcd`, totalShares, {
    ...CRM_BASE_URL,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// Update enable check-in for multiple shareholders
DaiHoiCoDongService.updateEnableCheckIn = function (ids, enableCheckIn) {
  return axiosInstance.put(
    `${BASE}/update-enable-checkin`,
    {
      ids,
      enableCheckIn,
    },
    {
      ...CRM_BASE_URL,
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

// Document (TaiLieu) endpoints
DaiHoiCoDongService.searchTaiLieu = function (data) {
  return axiosInstance.post(`${BASE}/tai-lieu/search-grid`, data, CRM_BASE_URL);
};

DaiHoiCoDongService.getTaiLieuById = function (id) {
  return axiosInstance.get(`${BASE}/tai-lieu/get-by-id?id=${id}`, CRM_BASE_URL);
};

DaiHoiCoDongService.uploadTaiLieu = function (formData) {
  return axiosInstance.post(`${BASE}/tai-lieu/upload`, formData, {
    ...CRM_BASE_URL,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

DaiHoiCoDongService.updateTaiLieu = function (data) {
  return axiosInstance.put(`${BASE}/tai-lieu/update`, data, CRM_BASE_URL);
};

DaiHoiCoDongService.deleteTaiLieu = function (id) {
  return axiosInstance.delete(`${BASE}/tai-lieu/delete?id=${id}`, CRM_BASE_URL);
};

// Export Excel endpoint
DaiHoiCoDongService.exportExcel = function (ids) {
  return axiosInstance.post(`${BASE}/export-excel`, ids, {
    ...CRM_BASE_URL,
    headers: {
      'Content-Type': 'application/json'
    },
  });
};

export default DaiHoiCoDongService;
